import { useContext } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import Cookies from "universal-cookie";


const RequireAuth = () => {

  
    const location = useLocation();
    const cookies = new Cookies();
    const authCookie = cookies.get('auth');

    return (
        authCookie ? <Outlet />
            : <Navigate to="/" state={{ from: location }} replace />

    );
}

export default RequireAuth;